export default __webpack_public_path__ + "static/media/04_photo.78f05cd6.jpg";